import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { BUSINESS_ACTIVITIES_TREE_QUERY } from 'graphql/businessActivity/queries'
// types
import { TRefetch } from 'types/refetch'
import { NetworkStatus } from '@apollo/client'
import { IBusinessActivity, IBusinessActivitiesResponse, IBusinessActivitiesQueryArgs } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOr, maxBy, pipe } from 'lodash/fp'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = { businessActivities: IBusinessActivitiesResponse }

interface Context {
  refetch: TRefetch<QueryResponse, IBusinessActivitiesQueryArgs>
  isLoading: boolean
  lastPosition: number
  businessActivities: IBusinessActivity[]
}

export const BusinessActivitiesAPIContext = React.createContext<Context>({} as any)

const BusinessActivitiesAPI: React.FC<Props> = ({ children }) => {
  const {
    data: treeQuery,
    refetch,
    loading,
    networkStatus
  } = useQuery<QueryResponse>(BUSINESS_ACTIVITIES_TREE_QUERY, {
    variables: {
      pagination: {
        pageSkip: 0,
        pageTake: 10000
      }
    }
  })

  const businessActivities: IBusinessActivity[] = (get(treeQuery, 'businessActivities.data') || []).map(
    (businessActivity) => ({
      ...businessActivity,
      title: businessActivity.description
    })
  )

  const lastPosition: number = pipe<any, any, any>(maxBy('position'), getOr(0, 'position'))(businessActivities)

  const value = {
    refetch,
    lastPosition,
    businessActivities,
    isLoading: loading && networkStatus === NetworkStatus.loading
  }

  return <BusinessActivitiesAPIContext.Provider value={value}>{children}</BusinessActivitiesAPIContext.Provider>
}

export default BusinessActivitiesAPI
